import { MONGO_DB_CONSTANTS } from "./mongoDb";
import { APACHE_CONSTANTS } from "./apache";
import { CERT_MANAGER_CONSTANTS } from "./certManager";
import { FERRETDB_CONSTANTS } from "./ferretDb";
import { GITLAB_CONSTANTS } from "./gitlabRunner";
import { GRAFANA_CONSTANTS } from "./grafana";
import { INGRESS_CONSTANTS } from "./ingress";
import { KAFKA_CONSTANTS } from "./kafka";
import { KEYCLOAK_CONSTANTS } from "./keycloak";
import { MARIADB_CONSTANTS } from "./mariaDb";
import { MINIO_CONSTANTS } from "./minio";
import { MySQL_CONSTANTS } from "./mySql";
import { PostgreSQL_CONSTANTS } from "./postgres";
import { NGINX_CONSTANTS } from "./nginx";
import { PostgreHA_CONSTANTS } from "./postgresha";
import { RabbitMQ_CONSTANTS } from "./rabbitMq";
import { REDIS_CONSTANTS } from "./redis";
import { WORDPRESS_CONSTANTS } from "./wordpress";

export const APP_CONSTANTS = {
  mongodb: MONGO_DB_CONSTANTS,
  apache: APACHE_CONSTANTS,
  certManager: CERT_MANAGER_CONSTANTS,
  ferretdb: FERRETDB_CONSTANTS,
  gitlabRunner: GITLAB_CONSTANTS,
  grafana: GRAFANA_CONSTANTS,
  nginxIngress: INGRESS_CONSTANTS,
  kafka: KAFKA_CONSTANTS,
  keycloak: KEYCLOAK_CONSTANTS,
  mariadb: MARIADB_CONSTANTS,
  minio: MINIO_CONSTANTS,
  mysql: MySQL_CONSTANTS,
  postgresql: PostgreSQL_CONSTANTS,
  nginx: NGINX_CONSTANTS,
  postgresqlHa: PostgreHA_CONSTANTS,
  rabbitmq: RabbitMQ_CONSTANTS,
  redis: REDIS_CONSTANTS,
  wordpress: WORDPRESS_CONSTANTS,
};
